import clsx from "clsx"
import { FC } from "react"
import { Button, IButton } from "ui/@button"
import { infoIcon } from "assets/icons"
import styles from "./index.module.scss"

interface IButtonInfo extends IButton {}

export const ButtonInfo: FC<IButtonInfo> = ({ className, ...props }) => {
  return (
    <Button className={clsx(styles.ButtonInfo, className)} {...props}>
      <img src={infoIcon} />
    </Button>
  )
}
